/**
 * @type {unknown}
 */
export const API_ROUTER_CONTEXT_DEFAULT_VALUE = null;

/**
 * @type {import("../../contexts/ApiFecher/ApiFetcher").ApiFetcherContextValue<any>}
 */
export const API_FETCHER_CONTEXT_DEFAULT_VALUE = {
  // @ts-ignore
  apiFetcher: () => {},
};
